import { render, staticRenderFns } from "./Naw.vue?vue&type=template&id=7be66208&"
import script from "./Naw.vue?vue&type=script&lang=js&"
export * from "./Naw.vue?vue&type=script&lang=js&"
import style0 from "./Naw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Naw.vue"
export default component.exports